import Card from "./Card";
import { Link } from "react-router-dom";
function Services() {
  return (
    <div className="container services">
        <h2 className="main-title text-center">VERTICALS</h2>
        <div className="card-cover">
            <div className="col-md-12">
                <div className="row">
                
                <div className="col-md-4 mb-2">
                <Link to="/Embedded-Systems" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                  <Card 
                    title="Embedded Systems" 
                    img="card2.png" 
                    text="Seionic Technologies excels in embedded systems development, providing comprehensive solutions from hardware design to software integration. Our team has deep expertise in firmware development, PCB design, and microcontroller integration, ensuring robust and efficient system performance." 
                    showButton={true}
                  />
                </Link>
              </div>
                    <div className="col-md-4 mb-2">
                    <Link to="/Intelligent-Transport" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                    <Card title="Intelligent Transport Systems" img="card3.png" text="Intelligent Transportation Systems (ITS) integrate advanced information and communication technologies into transportation networks to improve safety, efficiency, and sustainability. ITS reduces traffic congestion, enhances driver experiences, and promotes eco-friendly travel by optimizing traffic flow, providing real-time information, and improving road management."
                    showButton={true}
                     />
                    
                    </Link>
                    </div>

                    <div className="col-md-4 mb-2">
                    <Link to="/Display-Panel" className="card-link" style={{ textDecoration: "none", color: "inherit" }}>
                    <Card title="Interactive Display Panel" img="card1.png" text="The interactive panel display is a cutting-edge device designed for high-performance functionality. It features a 5-in-1 motherboard for stable operation and zero-gap bonding technology, ensuring low parallax and wider viewing angles. The 3mm anti-glare toughened glass enhances clarity under ambient light, while optional light-sensitive brightness adjustment adapts to different environments." 
                    showButton={true}/>
                    </Link>
                </div>

                    
                </div>
            </div>
        </div>
    </div>
  );
}
export default Services;
